import QueryManager from "../../../global/utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";
import {OpportunitiesFiltersTypes} from "./Opportunities.filters.types";

const curLocalStorageKey = getLocalStorageKey("officers_filters");

let opportunityFiltersSerializableDates = [
    OpportunitiesFiltersTypes.PostedDate,
    OpportunitiesFiltersTypes.ResponseDate,
]

let opportunityFiltersSerializableJoins = [
    OpportunitiesFiltersTypes.Keywords,
    OpportunitiesFiltersTypes.PopState,
    OpportunitiesFiltersTypes.Naics,
    OpportunitiesFiltersTypes.PscCode,
]

class OpportunitiesFiltersManagerClass extends QueryManager {}

const OpportunitiesFiltersManager = new OpportunitiesFiltersManagerClass({
    serializable: {
        dates: opportunityFiltersSerializableDates,
        joins: opportunityFiltersSerializableJoins
    },
    localStorageKey: curLocalStorageKey
});

export default OpportunitiesFiltersManager;